// eslint-disable-next-line no-restricted-imports
import cookies from 'js-cookie'

export const COOKIE_UPDATE_EVENT = 'cookieUpdate'

export const getCookie = (key: string): string | undefined => cookies.get(key)

export const setCookie = (key: string, value: string): void => {
  cookies.set(key, value, { path: '/' })
  triggerDomEvent()
}

export const deleteCookie = (key: string): void => {
  cookies.remove(key)
  triggerDomEvent()
}

const triggerDomEvent = () => {
  // It will propagate custom DOM event if we are on client side
  if (typeof window !== 'undefined') {
    window?.dispatchEvent?.(new Event(COOKIE_UPDATE_EVENT))
  }
}
